module.exports = __webpack_public_path__ + "static/media/ghost.5ad0dc49.svg";